import { render } from "./Locate.vue?vue&type=template&id=4f2dca8c"
import script from "./Locate.vue?vue&type=script&lang=js"
export * from "./Locate.vue?vue&type=script&lang=js"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__